export const WAREHOUSES_LIMITS_REDUCER_NAME = 'supplies-managment-front_warehouses-limits-module_WAREHOUSES_LIMITS_REDUCER_NAME';
